import axios from 'axios'
import constants from './constants'

var axiosInstance = axios.create()

axiosInstance.interceptors.request.use(config => {
    if (config.method !== 'OPTIONS') {
        config.headers.Authorization = 'Bearer ' + localStorage.getItem('token')
    }
    config.url = constants.API + config.url
    return config
})

axiosInstance.interceptors.response.use(
    function (response) {
        // Do something with response data
        return response
    },
    err => {
        return Promise.reject(err)
    }
)

export default axiosInstance